import React from 'react';
import { ArrowRightIcon, InfinityIcon } from 'lucide-react';
import { offers, Offer } from '../data/product';
interface FinalCtaProps {
  onSelectOffer: (id: Offer['id']) => void;
}
const buttonLabels: Record<Offer['id'], string> = {
  single: 'Get 1 for $39.95',
  trio: 'Get the Full-Shift Kit for $74.95',
  crew: 'Get 5 X1 for $119.85'
};
export function FinalCta({
  onSelectOffer
}: FinalCtaProps) {
  return <section aria-labelledby="final-heading" className="border-b border-white/10 bg-ink-950" data-id="element-202" data-mp="1jc3fmpoezx7w">
      <div className="mx-auto max-w-[1400px] px-4 py-16 text-center sm:px-6 lg:px-8 lg:py-24" data-id="element-203" data-mp="1ed0kpy25f7dn">
        <h2 id="final-heading" className="grit-headline mx-auto max-w-4xl text-[clamp(2.5rem,9vw,5.5rem)] font-extrabold uppercase text-offwhite" data-id="element-204" data-mp="1t37w5ttqnq4u">
          Stop holding the light.
          <br data-id="element-205" data-mp="224ed240av2ym" />
          <span className="text-grit-500" data-id="element-206" data-mp="2245wo24yxfio">Start wearing it.</span>
        </h2>

        <div className="mx-auto mt-6 max-w-md space-y-1 text-lg font-medium text-steel-300" data-id="element-207" data-mp="1x5kxm61gd1vt">
          <p data-id="element-208" data-mp="n6nuz9h62p22">Three lenses.</p>
          <p data-id="element-209" data-mp="n7fevn1eiyci">Built-in illumination.</p>
          <p data-id="element-210" data-mp="s4fkjwuc9z33">Both hands free.</p>
        </div>

        <p className="mx-auto mt-6 inline-flex items-center gap-2 border-2 gold-edge bg-[#1a1408] px-5 py-3" data-id="element-211" data-mp="s57hbazoa2uy">
          <InfinityIcon className="h-6 w-6 shrink-0 text-[#f2c94c]" aria-hidden="true" data-id="element-212" data-mp="x2h22dc49qcg" />
          <span className="grit-headline text-2xl font-extrabold uppercase gold-text sm:text-3xl" data-id="element-213" data-mp="124g8jw35l3dm">
            Lifetime free replacement
          </span>
        </p>

        <p className="mt-8 font-display text-3xl font-extrabold uppercase leading-none text-offwhite" data-id="element-214" data-mp="1b2rv9n0wfh0s">
          GritVue X1™
        </p>
        <p className="mt-1 text-xs font-bold uppercase tracking-[0.3em] text-grit-500" data-id="element-215" data-mp="1furyppg6gs24">Light where you look.</p>

        <div className="mx-auto mt-10 grid max-w-3xl gap-3 sm:grid-cols-3" data-id="element-216" data-mp="1kvfq4c8bjawv">
          {offers.map(offer => <a key={offer.id} href="#offer" onClick={() => onSelectOffer(offer.id)} className={`group flex items-center justify-center gap-2 px-5 py-4 font-display text-xl font-extrabold uppercase tracking-wide transition-[background-color,color,transform] duration-150 ease-grit active:translate-y-[2px] ${offer.featured ? 'bg-grit-500 text-ink-950 hover:bg-grit-400' : 'border-2 border-white/25 text-offwhite hover:border-grit-500 hover:text-grit-500'}`} data-id="element-217" data-mp="1pqmp56qn7rfg">
              {buttonLabels[offer.id]}
              <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-grit group-hover:translate-x-1" aria-hidden="true" data-id="element-218" data-mp="8hhb5b4eedua" />
            </a>)}
        </div>

        <p className="mt-10 font-display text-2xl font-extrabold uppercase tracking-[0.1em] text-offwhite" data-id="element-219" data-mp="ifdkpyhot0qa">
          GritVue
        </p>
        <p className="mt-1 text-xs font-bold uppercase tracking-[0.3em] text-steel-400" data-id="element-220" data-mp="2k68igvvgf9zn">See the job through.</p>
      </div>
    </section>;
}